import { FETCH_TEHCATS, FETCH_TEHCAT, FETCH_TEHS, FETCH_TEH } from './types';

export const fetchTehCats = () => dispatch => {
    fetch('https://sinomost.kz/API/catteh/cats/')
    .then(res => res.json())
    .then(tehcats => dispatch({
        type: FETCH_TEHCATS,
        payload: tehcats
    }));
};
export const fetchTehCat = (id) => dispatch => {
    fetch(`https://sinomost.kz/API/catteh/cat/${id}/`)
    .then(res => res.json())
    .then(tehcat => dispatch({
        type: FETCH_TEHCAT,
        payload: tehcat
    }));
};

export const fetchTehs = (id) => dispatch => {
    fetch(`https://sinomost.kz/API/catteh/tehs/${id}/`)
    .then(res => res.json())
    .then(tehs => dispatch({
        type: FETCH_TEHS,
        payload: tehs
    }));
};

export const fetchAllTehs = () => dispatch => {
    fetch(`https://sinomost.kz/API/catteh/tehs/`)
    .then(res => res.json())
    .then(tehs => dispatch({
        type: FETCH_TEHS,
        payload: tehs
    }));
};

export const fetchTeh = (id) => dispatch => {
    fetch(`https://sinomost.kz/API/catteh/teh/${id}/`)
    .then(res => res.json())
    .then(teh => dispatch({
        type: FETCH_TEH,
        payload: teh
    }));
};